var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "button-edit py-2 px-4"
  }, [_c('span', {}, [_vm._v(_vm._s(_vm.$t('photoauthedit_note')))]), _c('v-text-field', {
    staticClass: "pt-5",
    attrs: {
      "hide-details": "",
      "label": _vm.$t('photoauthedit_button')
    },
    model: {
      value: _vm.form.button,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "button", $$v);
      },
      expression: "form.button"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }